import * as React from 'react';

import Icon from './Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const MenuIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 18;
  const color = props.color || 'black';
  return <Icon name={'hamburger'} size={size} color={color} />;
};

export default React.memo(MenuIcon);
